import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout'

import {
  TikuRouters,
  IntegralSeckillRouters,
  shoppingMallRouters,
  liveManageRouters,
  questionProductionRouters,
  fallibilityPointRouters,
  scheduleRouters,
  hiringManageRouters,
  coursesRouters,
  caseManageRouters,
  YamiRouters,
  ZiliaoRouters,
  examManageRouters,
  ChongciRouters,
  bookCatalogRouters,
  bookManageRouters,
  componentsRouters,
  bookGenerationRouters,
} from './modules/project'
import {
  statisticsRouters,
  trackRouters,
  customerManageRouters,
  marketingManagementRouters,
  agentRouters,
  partTimeJobRouters,
  advertisementRouters,
  ActivityRouters,
  IssueKaoxunRouters,
  PartnerBackgroundRouters,
  PartnerManagementRouters,
  ManageExamtimeRouter,
} from './modules/management'
import { hrmRouters, examineRoute, examineImproveRoute, dutyPlanRoute } from './modules/hrm'
import {
  AbTestingRouters,
  MaterialLib,
  UpdateInfoRouters,
  WeixinRouters,
  systemSettingRouters,
  miniDevelopSetting,
  xbotManageRouters,
  cityManageRouters,
} from './modules/system'
import { Templates } from './modules/template'
import { qywxRouters } from './modules/qywx'
import { questionNeatenRoute, ehafoKanbanRoute, booksRoute, clinicalPathRoute, storyManageRoute, newTrackRoute } from './modules/independent'

export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true,
  },
  {
    path: '/404',
    hidden: true,
    component: () => import('@/views/exception/404'),
  },
  // 企业微信侧边栏页面
  ...qywxRouters,
  booksRoute,
]

export const asyncRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: {
      title: '首页',
      icon: 'home-4-line',
    },
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index'),
        meta: {
          title: '首页',
          icon: 'home-4-line',
        },
      },
    ],
  },
  // 管理
  {
    isGroup: true,
    name: 'manage_group',
    meta: {
      title: '管理',
    },
    children: [
      statisticsRouters,
      trackRouters,
      newTrackRoute,
      customerManageRouters,
      marketingManagementRouters,
      agentRouters,
      partTimeJobRouters,
      advertisementRouters,
      ActivityRouters,
      IssueKaoxunRouters,
      PartnerBackgroundRouters,
      PartnerManagementRouters,
      ManageExamtimeRouter,
    ],
  },
  // 项目
  {
    isGroup: true,
    name: 'project_group',
    meta: {
      title: '项目',
    },
    children: [
      TikuRouters,
      questionProductionRouters,
      IntegralSeckillRouters,
      liveManageRouters,
      shoppingMallRouters,
      fallibilityPointRouters,
      scheduleRouters,
      hiringManageRouters,
      coursesRouters,
      caseManageRouters,
      YamiRouters,
      ZiliaoRouters,
      examManageRouters,
      ChongciRouters,
      bookCatalogRouters,
      bookManageRouters,
      componentsRouters,
      bookGenerationRouters,
    ],
  },
  // 人资管理系统
  {
    isGroup: true,
    name: 'hrm_group',
    meta: {
      title: '人资管理系统',
    },
    children: [
      {
        path: '/hrm',
        href: 'http://' + window.location.host + '/hrm/manage_examine',
        // component: () => import('@/views/hrm/manageExamine/index'),
        meta: {
          title: '绩效考核',
          icon: 'star-smile-line',
          target: '_blank',
        },
      },
      dutyPlanRoute,
    ],
  },
  // 系统设置
  {
    isGroup: true,
    name: 'system_group',
    meta: {
      title: '系统设置',
    },
    children: [systemSettingRouters, MaterialLib, UpdateInfoRouters, AbTestingRouters, WeixinRouters, miniDevelopSetting, xbotManageRouters, cityManageRouters],
  },
  // 模板
  {
    isGroup: true,
    name: 'template_group',
    meta: {
      title: '模板',
    },
    children: [...Templates],
  },
  // 错误页面
  {
    path: '/exception',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '404',
        name: '404',
        meta: { title: '404' },
        component: () => import('../views/exception/404'),
      },
    ],
  },
  {
    name: 'NotMatch',
    path: '/:catchAll(.*)',
    redirect: '/exception/404',
    hidden: true,
  },
]

export const hrmRouterMap = [...hrmRouters, examineRoute, examineImproveRoute]

export const independentRouterMap = [questionNeatenRoute, ehafoKanbanRoute, clinicalPathRoute, storyManageRoute]

const router = createRouter({
  routes: constantRouterMap,
  history: createWebHistory(process.env.BASE_URL),
})

export default router
